//CHID - 1    Mahesh    18 / 01 / 2020     standByMD-1970: NLP Symptoms Implementation
//CHID - 2    Mahesh    17 / 01 / 2020     standByMD-1971: Symptom Selector Implementation 
//CHID - 3    Usha      07/02/2020         2525: NLP Symptoms auto selected
import initState from './initState'
import { generateJsonWebToken, checkAndGetSessionStorageValue } from "../../features/utils";
export function clearSymptomState({ setState }) {
    setState(initState())
}
export function addSymptom({ symptom, state: { currentSymptomsMap }, setState, actions }) {
    actions.setSortedSymptoms({
        currentSymptomsMap: {
            ...currentSymptomsMap,
            [symptom.id]: symptom
        }
    })
}
export function removeSymptom({ symptom, state: { currentSymptomsMap }, setState, actions }) {
    delete currentSymptomsMap[symptom.id]
    actions.setSortedSymptoms({
        currentSymptomsMap
    })
}
export function setSortedSymptoms({ currentSymptomsMap, setState }) {
    const currentSymptomTitles = Object.keys(currentSymptomsMap).map(k => currentSymptomsMap[k].common_name)
    const currentSymptomsSortedKeys = Object.keys(currentSymptomsMap).sort((a, b) => {
        // Sort by title
        const x = currentSymptomsMap[a].common_name
        const y = currentSymptomsMap[b].common_name
        return x < y ? -1 : x > y ? 1 : 0
    })
    setState({
        currentSymptomsMap,
        currentSymptomsSortedKeys,
        currentSymptomTitles
    })
}
//CHID-3 Start
export function nlpAddSymptom({ symptom, state: { currentSymptomsMap }, setState, actions }) {
    actions.nlpSetSortedSymptoms({
        currentSymptomsMap: {
            ...currentSymptomsMap,
            [symptom.id]: symptom
        }
    })
}
export function nlpRemoveSymptom({ symptom, state: { currentSymptomsMap }, setState, actions }) {
    delete currentSymptomsMap[symptom.id]
    actions.nlpSetSortedSymptoms({
        currentSymptomsMap
    })
}
export function nlpSetSortedSymptoms({ currentSymptomsMap, setState }) {

    const currentSymptomTitles = Object.keys(currentSymptomsMap).map(k => currentSymptomsMap[k].common_name)
    const currentSymptomsSortedKeys = Object.keys(currentSymptomsMap).sort((a, b) => {
        // Sort by title
        const x = currentSymptomsMap[a].common_name
        const y = currentSymptomsMap[b].common_name
        return x < y ? -1 : x > y ? 1 : 0
    })
    setState({
        currentSymptomsMap,
        currentSymptomsSortedKeys,
        currentSymptomTitles
    })
}
//CHID-3 End
export async function refreshSymptoms({ setState, actions ,state}) {
    const { triageRequest } = state;
    let { ageInYears } = triageRequest;
    var jwtAccess_Token = generateJsonWebToken()
    var access_Token = checkAndGetSessionStorageValue("accessToken")
    try {
        var symptomSearchResult = await actions.sendTriageRequest({
            action: "refreshSymptomDatabase",
            data: {
                LanguageId: getLanguage(lang),
                Age: ageInYears,
                jwtAccessToken : jwtAccess_Token,
                accessToken : access_Token,
            }
            });
        console.log('searchSymptoms result', symptomSearchResult)
        /*
        // Sort by title
        symptomSearchResult.sort((a, b) => {
          const x= a.title
          const y = b.title
          return x < y ? -1 : x > y ? 1 : 0
        })
        setState({ symptomSearchResult, symptomSearchError: false })
        */
        setState({ symptomSearchResult, symptomSearchError: false })
    } catch (e) {
        console.log('searchSymptoms error', e)
        setState({ symptomSearchResult: [], symptomSearchError: true })
    }
}
export function setSymptomSearchResult({ symptomSearchResult, setState }) {
    setState({ symptomSearchResult })
}
//CHID-2 1971
export async function searchSymptoms({ text, allSymptoms, setState, actions }) {
    try {
        const searchTerm = text.toString()
        const symptomSearchResult = []
        for (let symptom of allSymptoms) {
            if (symptom.common_name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1) {
                let { id, common_name } = symptom
                symptomSearchResult.push({ id, common_name })
            }
        }
        // Sort by title
        symptomSearchResult.sort((a, b) => {
            let x = a.common_name
            let y = b.common_name
            return x < y ? -1 : x > y ? 1 : 0
        })
        setState({ symptomSearchResult, symptomSearchError: false })
        console.log('searchSymptoms result', symptomSearchResult)

    } catch (e) {
        console.log('searchSymptoms error', e)
        setState({ symptomSearchResult: [], symptomSearchError: true })
    }
}
export function setPrimarySymptom({ primarySymptom, setState }) {
    setState({
        primarySymptom
    })
}
//CHID-1 1970 start
export async function searchSymptomsByText({ text, lang,setState, actions,state }) {
    const { triageRequest } = state;
    var jwtAccess_Token = generateJsonWebToken()
  var access_Token = checkAndGetSessionStorageValue("accessToken")
  let { ageInYears } = triageRequest;
    try { 
        let searchTerm = text.toString();
        searchTerm = searchTerm.replace(/(?:\r\n|\r|\n)/g, ' ');
        if(searchTerm.trim().length > 0)
        {
        var symptomSearchResults = await actions.sendTriageRequest({
            action: "searchSymptomsByTexts",
            data: {
                searchText: searchTerm ,
                Language:lang,
                Age:ageInYears,
                jwtAccessToken : jwtAccess_Token,
                accessToken : access_Token,
            }
            });   
        const symptomSearchResult = symptomSearchResults.symptoms.mentions
        //CHID-3 Start
        if (symptomSearchResult !== undefined || symptomSearchResult.length > 0) {

            for (let i = 0; i < symptomSearchResult.length; i++) {

                actions.nlpAddSymptom({ symptom: symptomSearchResult[i] })
               
                setState({
                    symptomsAdded: [
                        ...(state.symptomsAdded || []),
                        symptomSearchResult[i].common_name
                    ]
                })
            }
        }
    }
        //CHID-3 End
        setState({ symptomSearchResult, symptomSearchError: false })
    }
    catch (e) {
        console.log('searchSymptoms error', e)
        setState({ symptomSearchResult: [], symptomSearchError: true })
    }
}
//CHID-1 1970 end
    
